import {
    faCheckSquare,
    faCloud,
    faCommentDots,
    faEnvelope,
    faHistory,
    faHome,
    faPlus,
    faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { IAtendimentoExtraDetalhado } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { EnviarEmail } from "../../../../../Pages/Cobranca/Atendimento/ModalEnviarEmail";
import { ModalGerarPdfEmail } from "../../../../../Pages/Cobranca/Atendimento/ModalGerarPdfEmail";
import BigActionButton from "../../../../Buttons/BigActionButton";
import ModalComponent from "../../../../Modais";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import CasoAtividade from "../../../HistoricoClienteCobranca/ComponenteHistorico/CasoAtividade";
import CadastrarHistorico from "../../../HistoricoClienteCobranca/CadastrarHistorico";
import { ACESSOS } from "../../../../../Routes/Acessos";
import CardBoard from "../../../../../Pages/Cobranca/Atendimento/CardBoard";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { GetBugCardDevOpsByIDCasoController } from "../../../../../Controllers/DevOps/DevOpsController";
import CustomHeaderCard from "../../../../../Pages/Cobranca/Atendimento/CardBoard/CustomHeaderCard";
import { useUserInfor } from "../../../../../Context/User";
import CadastrarVisita from "../../../../../Pages/Vendas/GestaoDeVisitas/CadastrarVisita";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import HistoricoWhatsapp from "./HistoricoWhatsapp/HistoricoWhatsapp";

interface IAcoesInteracaoProps {}

export default function AcoesInteracao(props: IAcoesInteracaoProps) {
    const AtendimentoPageContext = useAtendimentoPage();

    const { OrgInfor } = useUserInfor();

    const Atendimento = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;

    const capysEng = "6379F504-FCF5-4e99-B7E2-92ACF6878448";

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [modalCloseEmail, setModalCloseEmail] = useState(false);
    const [modalCloseHistorico, setModalCloseHistorico] = useState(false);

    const {
        value: getBugCardDevOpsByIDCaso,
        execute: GetBugCardDevOpsByIDCaso,
    } = useAsyncEffect(async () => {
        if (
            OrgInfor.ID_ORGANIZACAO === capysEng &&
            AtendimentoPageContext.idModulo === ACESSOS.ATENDIMENTO.ID_MODULO
        ) {
            const res = await GetBugCardDevOpsByIDCasoController(
                Atendimento.ID_CASO
            );

            return res;
        }
    }, [Atendimento.ID_CASO]);

    const validarEdicao =
        getBugCardDevOpsByIDCaso && getBugCardDevOpsByIDCaso?.devOpsCard;

    return (
        <div className="col-12">
            <div className="card card-custom px-8 py-4 mb-5">
                {/* <hr /> */}
                <div className="g-5  d-flex flex-row flex-wrap justify-content-center">
                    {/* <div className="d-flex align-items-center">
                        <h6 className="text-center mb-0">Ações de Interação</h6>
                    </div> */}
                    {!AtendimentoPageContext.bloquearInteracoes && (
                        <>
                            {Atendimento.ID_CASO && (
                                <BigActionButton
                                    icon={faPlus}
                                    color="success"
                                    disabled={Atendimento?.FL_CASO_PARALIZADO}
                                    onClick={() => {
                                        setModalCloseHistorico(true);
                                        setShow(true);
                                        setModal({
                                            headerComponent:
                                                "Cadastro de Histórico",
                                            IconHeader: faCommentDots,
                                            Component: () => (
                                                <CadastrarHistorico
                                                    setShow={setShow}
                                                />
                                            ),
                                            noFooter: true,
                                            size: "lg",
                                        });
                                    }}
                                    tooltip="Cadastrar Histórico"
                                >
                                    {""}
                                </BigActionButton>
                            )}

                            <BigActionButton
                                icon={faEnvelope}
                                color="success"
                                disabled={Atendimento?.FL_CASO_PARALIZADO}
                                onClick={() => {
                                    setModalCloseEmail(true);
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Enviar Email",
                                        IconHeader: faEnvelope,
                                        Component: () => (
                                            <EnviarEmail
                                                ID_CASO={Atendimento.ID_CASO}
                                                ID_CONTA={Atendimento.ID_CONTA}
                                                ID_CONTATO={
                                                    Atendimento.ID_CONTATO
                                                }
                                                setShow={setShow}
                                                assuntoDefault={
                                                    AtendimentoPageContext.TIPO_CASO ===
                                                    "Cobranca"
                                                        ? "Informativo de Cobrança"
                                                        : ""
                                                }
                                            />
                                        ),
                                        scrollable: true,
                                        size: "xl",
                                    });
                                }}
                                tooltip="Enviar Email"
                            >
                                {""}
                            </BigActionButton>
                            <BigActionButton
                                icon={faCheckSquare}
                                color="primary"
                                disabled={Atendimento?.FL_CASO_PARALIZADO}
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Cadastrar Atividade",
                                        IconHeader: faCheckSquare,
                                        Component: () => (
                                            <CasoAtividade setShow={setShow} />
                                        ),
                                        size: "lg",
                                    });
                                }}
                                tooltip="Cadastrar Atividade"
                            >
                                {""}
                            </BigActionButton>

                            {ACESSOS.VENDAS.ID_MODULO ===
                                AtendimentoPageContext.idModulo && (
                                <BigActionButton
                                    icon={faWhatsapp}
                                    color="success"
                                    disabled={Atendimento?.FL_CASO_PARALIZADO}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent:
                                                "Histórico WhatsApp",
                                            IconHeader: faHistory,
                                            Component: () => (
                                                <HistoricoWhatsapp
                                                    setShow={setShow}
                                                />
                                            ),
                                            scrollable: true,
                                            size: "xl",
                                        });
                                    }}
                                    tooltip={
                                        AtendimentoPageContext.lstInforVendas
                                            ?.CONTA.NR_TELEFONE
                                            ? "Enviar Mensagem WhatsApp"
                                            : "Sem telefone cadastrado"
                                    }
                                >
                                    {""}
                                </BigActionButton>
                            )}

                            <BigActionButton
                                icon={faPrint}
                                color="danger"
                                disabled={Atendimento?.FL_CASO_PARALIZADO}
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Gerar Documento",
                                        IconHeader: faPrint,
                                        Component: () => (
                                            <ModalGerarPdfEmail
                                                ID_CASO={Atendimento.ID_CASO}
                                                ID_CONTA={Atendimento.ID_CONTA}
                                                ID_CONTATO={
                                                    Atendimento.ID_CONTATO
                                                }
                                                setShow={setShow}
                                            />
                                        ),
                                        scrollable: true,
                                        size: "xl",
                                    });
                                }}
                                tooltip="Gerar Documento"
                            >
                                {""}
                            </BigActionButton>

                            {AtendimentoPageContext.idModulo ===
                                ACESSOS.VENDAS.ID_MODULO && (
                                <BigActionButton
                                    icon={faHome}
                                    color="primary"
                                    disabled={Atendimento?.FL_CASO_PARALIZADO}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Cadastrar Visita",
                                            IconHeader: faHome,
                                            Component: () => (
                                                <CadastrarVisita
                                                    setShow={setShow}
                                                />
                                            ),
                                            size: "lg",
                                        });
                                    }}
                                    tooltip="Cadastrar Visita"
                                >
                                    {""}
                                </BigActionButton>
                            )}

                            {OrgInfor.ID_ORGANIZACAO === capysEng &&
                                AtendimentoPageContext.idModulo ===
                                    ACESSOS.ATENDIMENTO.ID_MODULO && (
                                    <BigActionButton
                                        icon={faCloud}
                                        color="info"
                                        disabled={
                                            Atendimento?.FL_CASO_PARALIZADO
                                        }
                                        onClick={() => {
                                            setShow(true);
                                            setModal({
                                                headerComponent: "",
                                                customHeader: (
                                                    <CustomHeaderCard
                                                        validarEdicao={
                                                            validarEdicao
                                                        }
                                                        setShow={setShow}
                                                        getBugCardDevOpsByIDCaso={
                                                            getBugCardDevOpsByIDCaso
                                                        }
                                                        setModal={setModal}
                                                    />
                                                ),
                                                IconHeader: faCloud,
                                                Component: () => (
                                                    <>
                                                        {Number(
                                                            localStorage.getItem(
                                                                "vincularCards"
                                                            )
                                                        ) === 0 &&
                                                            !validarEdicao && (
                                                                <>
                                                                    <p className="text-center">
                                                                        Deseja
                                                                        vincular
                                                                        um card
                                                                        já
                                                                        existente
                                                                        a esse
                                                                        atendimento?
                                                                    </p>
                                                                    <div className="d-flex justify-content-center">
                                                                        <button
                                                                            className="btn btn-primary font-weight-bold mr-2"
                                                                            onClick={() => {
                                                                                setShow(
                                                                                    false
                                                                                );
                                                                                localStorage.setItem(
                                                                                    "vincularCards",
                                                                                    String(
                                                                                        1
                                                                                    )
                                                                                );
                                                                                setTimeout(
                                                                                    () => {
                                                                                        setShow(
                                                                                            true
                                                                                        );
                                                                                    },
                                                                                    0
                                                                                );
                                                                            }}
                                                                        >
                                                                            Sim
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-light font-weight-bold"
                                                                            onClick={() => {
                                                                                setShow(
                                                                                    false
                                                                                );
                                                                                localStorage.setItem(
                                                                                    "vincularCards",
                                                                                    String(
                                                                                        2
                                                                                    )
                                                                                );
                                                                                setTimeout(
                                                                                    () => {
                                                                                        setShow(
                                                                                            true
                                                                                        );
                                                                                    },
                                                                                    500
                                                                                );
                                                                            }}
                                                                        >
                                                                            Não
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}

                                                        <CardBoard
                                                            setShow={setShow}
                                                            getBugCardDevOpsByIDCaso={
                                                                getBugCardDevOpsByIDCaso
                                                            }
                                                            GetBugCardDevOpsByIDCaso={
                                                                GetBugCardDevOpsByIDCaso
                                                            }
                                                            validarEdicao={
                                                                validarEdicao ??
                                                                undefined
                                                            }
                                                        />
                                                    </>
                                                ),
                                                size: "xl",
                                            });
                                        }}
                                        tooltip="Vincular Card"
                                    >
                                        {""}
                                    </BigActionButton>
                                )}
                        </>
                    )}

                    <ModalComponent
                        show={show}
                        setShow={setShow}
                        ModalComponent={modal}
                        modalClose={modalCloseEmail || modalCloseHistorico}
                        setModalClose={
                            setModalCloseEmail || setModalCloseHistorico
                        }
                    />
                </div>
            </div>
        </div>
    );
}
